export enum BalanceType {
    CASH = "cash",
    BONUS = "bonus",
    BOTH = "both"
}
